import type { ProductAssetsFragmentEnhanced } from '@models/enhanced-fragments';
import { TRANSLATION_CONFIGURATION } from '@libs/constants';

export type AssetSource = {
  key?: string;
  uri: string;
  contentType?: string;
};

export enum AssetSourceType {
  Preview = 'preview',
  Download = 'download',
}

export const getAssetSourceDefaultLocale = (locale: string): string =>
  // default for de-CH, de-AT, de-BE is de
  // default for all non german locales is en
  new Intl.Locale(locale).language === 'de'
    ? TRANSLATION_CONFIGURATION.extraFallbackLocale
    : TRANSLATION_CONFIGURATION.fallbackLocale;

export const getSourceItemByDefaultLanguageAndType = (
  asset: ProductAssetsFragmentEnhanced,
  type: AssetSourceType,
  locale: string
): AssetSource | null => {
  const findAssetSources = (currentLocale: string) =>
    asset.sources.find((sourceItem: AssetSource) => sourceItem.key === `${currentLocale}_${type}`);

  let item = findAssetSources(locale);

  if (asset.key.startsWith('attr_image_') || asset.key.startsWith('attr_drawing_')) {
    [item] = asset.sources;
  }

  if (!item) {
    // use fallback locale if no asset source was found for current locale
    // show default german version for de-CH, de-AT, de-BE,
    // show english version for all non german locales
    item = locale.toLowerCase().startsWith('de')
      ? findAssetSources(getAssetSourceDefaultLocale(locale)) // de-DE
      : findAssetSources(TRANSLATION_CONFIGURATION.fallbackLocale); // en-EU
  }

  return item ?? null;
};
